import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_REVENUE_PPMU_SUNRISE_DOUBLE_HOLDOUT_EXPERIMENT = defineFcm(
	'revenue_ppmu_sunrise_double_holdout_experiment',
)
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				experimentName: { type: 'string' },
			},
		}),
	)
	.withDefault(undefined)
	.toConfig();
